import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7d972db8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=7d972db8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d972db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d972db8')) {
      api.createRecord('7d972db8', component.options)
    } else {
      api.reload('7d972db8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7d972db8&scoped=true", function () {
      api.rerender('7d972db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calls/Index.vue"
export default component.exports